import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  FileAttachedDocumentType,
  FileMessageSenderType,
} from '@savgroup-front-common/constants/shared/message';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

export interface SendFileMessageAttachedDocument {
  documentUrl: string;
  documentExtension: string;
  displayName: string;
  attachedDocumentType: FileAttachedDocumentType;
}

export interface SendFileMessageCommandPayload {
  senderType: FileMessageSenderType;
  recipientType: FileMessageSenderType;
  attachedDocuments: SendFileMessageAttachedDocument[];
  messageContent: string;
  from: string;
}

interface SendFileMessageCommandArgs {
  fileId: string;
  payload: SendFileMessageCommandPayload;
}

export async function sendFileMessageCommand({
  fileId,
  payload,
}: SendFileMessageCommandArgs): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    return await apiCall<BaseBackResponse>(
      `${APIConfiguration.workflow}files/${fileId}/message`,
      {
        method: SUPPORTED_METHODS.PUT,
        json: payload,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
